import Emitter from '../../services/eventEmmiter/EventEmmiter';
import * as style from '../../styledComponent/style.css';
import classes from '../../framework/framework/tools/classes';
import { EventTypes } from '../../services/eventEmmiter/EventTypes';

import React = require('react');

interface IProps {
    }
interface IState {
    show: boolean;
    content: React.ReactElement;
}

export default class SideBarOnEvent extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            show: false,
            content: <></>
        };
    }

    componentDidMount() {
        Emitter.on(EventTypes.RightSideBar, (elem) => this.setState({ content: elem, show: true }));
        Emitter.on(EventTypes.Modal, () => this.setState({ show: false }));
    }

    render() {
        if (!this.state.show) { return <></>; }

        return <div className={style.sideBarWrapper} onClick={() => this.setState({ content: null, show: false })}>
            <div className={classes(style.sideBar)} onClick={(event) => event.stopPropagation()}>
                <div className={style.sideBarContent}>
                    {this.state.content}
                </div>
            </div>
        </div>;
    }
}
